module.exports = __webpack_public_path__ + "img/payment-style-checkbox.a386e396.svg";